const Gender = Object.freeze({
    MALE: 0,
    FEMALE: 1,
    OTHER: 2,
    UNKNOWN: 3
})

export default Gender